import React from 'react';
import { dataHooks } from '../../constants';
import { classes, st } from '../../ListItemAction.st.css.js';
export const Icon = ({ suffixIcon, size, subtitle, }) => {
    return React.cloneElement(suffixIcon, {
        size: size === 'medium' ? 24 : 18,
        className: st(classes.suffixIcon, { subtitle: Boolean(subtitle) }),
        'data-hook': dataHooks.suffixIcon,
    });
};
//# sourceMappingURL=SuffixIcon.js.map